import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Card,
  Carousel,
  Col,
  Form,
  ProgressBar,
  Row,
} from "react-bootstrap";
import { NavLink, useNavigate} from "react-router-dom";
import apiFc from "../../../services/APIFc";
import { decryptData } from "../../../functions/cryptoUtils";
import { AlertDialogInterface } from "../../common/Interfaces";
import {
  formatearPrecio,
  tamañoImagenNuevo,
} from "../../../functions/Procedimientos";
import ProductosDestacadosCampana from "../../common/ProductosDestacadosCampana";
import CardGrupo from "../../Card Grupos/CardGrupo";
import ExtraLargeModal from "../../common/ExtraLargeModal";

const Campana = () => {
  const encryptedUser = useSelector((store: any) => store.authreducer.user);
  const user = decryptData(encryptedUser);
  const mostrarInformacionRaw = useSelector(
    (store: any) => store.authreducer.mostrarInformacion
  );
  const mostrarInformacion = useMemo(
    () => decryptData(mostrarInformacionRaw) || false,
    [mostrarInformacionRaw]
  );
  const marcasRaw = useSelector((store: any) => store.principalreducer.marcas);
  const marcas = useMemo(() => decryptData(marcasRaw) || [], [marcasRaw]);
  const [filtroLocal, setFiltroLocal] = useState("");
  const [masCompradosCampana, setMasCompradosCampana] = useState<any>();
  const [compradosCampana, setCompradosCampana] = useState<any>();
  const [clienteRanking, setClienteRanking] = useState<any>();
  const [importeCompraCampana, setImporteCompraCampana] = useState<any>();
  const [pageSize, setPageSize] = useState(8);
  const [selectedGroup, setSelectedGroup] = useState<any>({});
  const [articulosGrupo, setArticulosGrupo] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [items, setItems] = useState([]);
  const [showDetalle, setShowDetalle] = useState(false);
  const navigate = useNavigate();
  const importeObjetivo = 200000;
  const [alertDialog, setAlertDialog] = useState<AlertDialogInterface>({
    id: "1",
    visible: false,
    severity: "success", // severity="error" / "warning" / "info" / "success"
    timeOut: 2000, // severity="error" / "warning" / "info" / "success"
    cabecera: "Agregado!",
    texto: "el producto fue agregado.",
  });

  useEffect(() => {
    importeCompra();
    ranking();
    productoMasCompradoCampana();
    productosCampana();
  }, []);

  const importeCompra = () => {
    apiFc
      .get(`/web/campana/ingco/importecompra`)
      .then((res) => {
        setImporteCompraCampana(res.data);
      })
      .catch((error) => {})
      .finally(() => {});
  };

  const ranking = () => {
    apiFc
      .get(`/web/campana/ingco/clientes/ranking`)
      .then((res) => {
        setClienteRanking(res.data);
      })
      .catch((error) => {})
      .finally(() => {});
  };

  const productoMasCompradoCampana = () => {
    apiFc
      .get(`/web/campana/ingco/productos/mascomprado`)
      .then((res) => {
        setMasCompradosCampana(res.data);
      })
      .catch((error) => {})
      .finally(() => {});
  };

  const productosCampana = () => {
    apiFc
      .get(`/web/campana/ingco/productos/comprados`)
      .then((res) => {
        setCompradosCampana(res.data);
      })
      .catch((error) => {})
      .finally(() => {});
  };

  useEffect(() => {
    if (selectedGroup.articuloGrupoId > 0) {
      try {
        apiFc
          .get(`/articuloGrupos/${selectedGroup.articuloGrupoId}/articulos`)
          .then((res) => {
            setArticulosGrupo(res.data);
            setShowDetalle(true);
          });
      } catch (error) {}
    }
  }, [selectedGroup]);

  const fetchData = () => {
    apiFc
      .get(`/web/articulos/marcas/13/articulogrupos?page=0&rows=1000`)
      .then((res) => {
        setItems(res.data.content);
        setFiltroLocal("");
        window.scrollTo(0, 0);
      });
  };

  useEffect(() => {}, [filtroLocal]);
  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    fetchData();
  };

  const handleOpenModal = (articulo: any) => {
    setSelectedGroup(articulo);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedGroup({});
  };

  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
  };

  //Para el paginado-->
  // const pageSizeOptions = [
  //   { value: 8, label: "Mostrar 8" },
  //   { value: 16, label: "Mostrar 16" },
  //   { value: marcas.length, label: "Mostrar todas" },
  // ];

  // calculo de porcentaje para la barra
  const calcularProgreso = () => {
    if (!importeCompraCampana) return 0;
    if (importeCompraCampana >= importeObjetivo) return 100;
    const progreso = (importeCompraCampana / importeObjetivo) * 100;
    return Math.min(Math.round(progreso), 100);
  };

  const calcularProgresoCampana = () => {
    if (!compradosCampana || compradosCampana.total === 0) return 0;
    return Math.min(
      100,
      Math.round((compradosCampana.comprados / compradosCampana.total) * 100)
    );
  };
  const clientesPermitidos = [2268, 1176, 186, 1144, 1432];
  const clienteTienePermiso = clientesPermitidos.includes(user?.clienteCodigo);

  if (!clienteTienePermiso) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <Card
              className="text-center border-0 shadow-lg card-hover"
              style={{
                borderRadius: "15px",
                overflow: "hidden",
                border: "none",
              }}
            >
              <Card.Header
                as="h4"
                className="py-3 text-white"
                style={{
                  backgroundColor: "#FFB300",
                  borderBottom: "none",
                }}
              >
                <i className="fas fa-rocket me-2"></i>
                Sección Exclusiva para Clientes: "Campaña"
              </Card.Header>

              <Card.Body
                className="py-4 px-5"
                style={{ backgroundColor: "#fff" }}
              >
                <div className="mb-4">
                  <div className="icon-container">
                    <i
                      className="si si-user-follow"
                      style={{
                        fontSize: "x-large",
                        color: "#FFB300",
                      }}
                    ></i>
                  </div>
                  <Card.Title className="h4 mb-3" style={{ color: "#FFB300" }}>
                    Aprovecha beneficios exclusivos
                  </Card.Title>
                  <Card.Text className="text-dark mb-4">
                    <strong style={{ color: "#000" }}>
                      Esta sección está disponible solamente para clientes de
                      "Campaña"
                    </strong>
                    <br />
                    <br />
                    Próximamente podrás crear presupuestos completos para tus
                    clientes, combinando artículos de ferretería con productos
                    de otros proveedores en un mismo documento profesional.
                    <br />
                    <br />
                    Simplificaremos todo el proceso para que ahorres tiempo y
                    puedas enfocarte en hacer crecer tu negocio.
                  </Card.Text>
                </div>

                <div className="d-flex justify-content-center gap-3">
                  <Button
                    variant="outline-dark"
                    onClick={() => navigate("/principal/inicio")}
                    className="px-4 py-2 rounded-pill"
                    style={{
                      fontWeight: "600",
                      borderWidth: "2px",
                      borderColor: "#FFB300",
                      color: "#FFB300",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.backgroundColor = "#FFB300";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#FFB300";
                    }}
                  >
                    <i className="fas fa-home me-2"></i>
                    Volver al inicio
                  </Button>
                </div>
              </Card.Body>

              <Card.Footer
                className="py-3"
                style={{
                  backgroundColor: "#FFF2CC", // tono pastel suave
                  borderTop: "1px solid #FFB300",
                }}
              >
                <small className="text-dark">
                  <i className="fas fa-clock me-1"></i>
                  Disponible próximamente - Solicítalo ahora para tener acceso
                  prioritario
                </small>
              </Card.Footer>
            </Card>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <ExtraLargeModal
        show={showModal}
        handleClose={handleCloseModal}
        selectedGroup={selectedGroup}
        alertDialog={alertDialog}
        // setAlertDialog={setAlertDialog}
        windowWidth={window.innerWidth}
      />
      <Col>
        <div
          className="justify-content-center empezamosPorAca carousel-inicio-fix"
          style={{ position: "relative", top: "-20px" }}
        >
          <div className="Withcontrols">
            <Carousel>
              <Carousel.Item>
                <a
                  // href="https://whatsapp.com/channel/0029VagMNruI1rchr3HAYa3z"
                  className="pd-l-40 pd-r-40"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="d-flex wd-100p justify-content-center align-items-center  seguimoaca carousel-inicio-img-fix "
                    src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/inicio-carrusel/carrusel1${tamañoImagenNuevo(
                      window.innerWidth
                    )}.webp`}
                    alt=""
                    onError={(e: any) => {
                      // e.target.src = `../../../../img/Imagenes/Grupos/noimg.png`
                      //e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/inicio-carrusel/carrusel1_rot${tamañoImagen(window.innerWidth)}.png`
                    }}
                  />
                </a>
              </Carousel.Item>
              <Carousel.Item>
                <NavLink to={""} className="pd-l-40 pd-r-40">
                  <img
                    className="d-flex wd-100p justify-content-center align-items-center  seguimoaca carousel-inicio-img-fix "
                    src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/inicio-carrusel/carrusel2${tamañoImagenNuevo(
                      window.innerWidth
                    )}.webp`}
                    alt=""
                    onError={(e: any) => {
                      // e.target.src = `../../../../img/Imagenes/Grupos/noimg.png`
                      //e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/inicio-carrusel/carrusel2_rot${tamañoImagen(window.innerWidth)}.png`
                    }}
                  />
                </NavLink>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
        <Row>
          <Col xs={12} md={3} className="mb-3 mb-md-0">
            <Card className="h-90 mt-4">
              <Card.Body className="pt-4 px-4">
                <Row className="mb-3 text-center">
                  <p className="text-primary fw-bold fs-5 mb-0">INGCO Select</p>
                </Row>
                <Row className="text-center mb-3">
                  <Col xs={12} className="mb-2">
                    <p className="text-dark fs-6 mb-1">Producto más comprado</p>
                  </Col>
                  <Col xs={12}>
                    <div
                      className="d-flex justify-content-center align-items-center mx-auto"
                      style={{ width: 200, height: 200 }}
                    >
                      {masCompradosCampana && (
                        <img
                          className="w-100 h-100 object-fit-cover"
                          src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/${masCompradosCampana.articulo.articuloImagenGXI}`}
                          alt="Producto más comprado"
                          onError={(e: any) => {
                            e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Grupos/noimg.png`;
                          }}
                        />
                      )}
                    </div>
                  </Col>
                  <Col xs={12} className="mt-2">
                    {masCompradosCampana && (
                      <p className="text-muted fs-6 mb-0">
                        <strong>
                          {masCompradosCampana.articulo.articuloDescripcion}
                        </strong>
                      </p>
                    )}
                  </Col>
                </Row>
                <div className="mb-4">
                  <p className="text-dark fs-6 mb-2 d-flex justify-content-center">Progreso de Campaña</p>
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">{calcularProgreso()}%</span>
                  </div>
                  <ProgressBar
                    variant={calcularProgreso() >= 100 ? "success" : "primary"}
                    now={calcularProgreso()}
                    style={{
                      height: "10px",
                      borderRadius: "5px",
                      backgroundColor: "#e9ecef",
                    }}
                  />
                  <div className="d-flex justify-content-between mt-2">
                    <small className="text-muted">
                      <strong>
                        Importe actual:{" "}
                        {formatearPrecio({
                          valor: importeCompraCampana?.toFixed(2),
                        })}
                      </strong>
                    </small>
                    <small className="text-muted">
                      <strong>
                        Objetivo:{" "}
                        {formatearPrecio({
                          valor: importeObjetivo?.toFixed(2),
                        })}
                      </strong>
                    </small>
                  </div>
                </div>
                <div className="mb-4">
                  <p className="text-dark fs-6 mb-2 justify-content-center d-flex">
                    Productos Comprados
                  </p>
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">
                      {calcularProgresoCampana()}%
                    </span>
                  </div>
                  <ProgressBar
                    variant={
                      calcularProgresoCampana() >= 100 ? "success" : "primary"
                    }
                    now={calcularProgresoCampana()}
                    style={{
                      height: "10px",
                      borderRadius: "5px",
                      backgroundColor: "#e9ecef",
                    }}
                  />
                  <div className="d-flex justify-content-between mt-2">
                    <small className="text-muted">
                      <strong>Comprados: {compradosCampana?.comprados}</strong>
                    </small>
                    <small className="text-muted">
                      <strong>Total linea Ingco: {compradosCampana?.total}</strong>
                    </small>
                  </div>
                </div>

                {/* Cliente top */}
                <div className="text-center mt-4">
                  <p className="text-dark fs-6 mb-2">Cliente Top</p>
                  <p className=" fw-bold fs-4 mb-0">{clienteRanking}</p>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={9}>
            <div className="total text-center mt-3">
              <Row>
                <ProductosDestacadosCampana />
              </Row>
              <Row className="justify-content-center">
                <Card className="wd-100p">
                  <Card.Header className=" pb-0 paso1">
                    <div className="d-flex justify-content-between">
                      <h4 className="card-title mg-b-0">
                        Buscar productos INGCO
                      </h4>
                    </div>
                    {mostrarInformacion && (
                      <p className="tx-12 tx-gray-500 mb-2">
                        {`El buscador buscará los primeros 20 productos INGCO. Utilice el punto (.) para buscar por código. Ejemplo: coloque .252 para buscar "BALDE PLASTICO VOSS2000 ALBAÑIL MANIJA INYECTADA"`}
                      </p>
                    )}
                  </Card.Header>
                  <Card.Body className="p-2">
                    <Col md={12} sm={9} xs={12}>
                      <Form onSubmit={handleSearch}>
                        <Row className="align-items-center">
                          <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                            <div className="input-group">
                              <Form.Control
                                type="text"
                                className="form-control"
                                placeholder="Buscar ..."
                                onFocus={(e) => e.target.select()}
                                onChange={(e: any) =>
                                  setFiltroLocal(e.target.value)
                                }
                              />
                              <Button
                                variant="primary"
                                type="submit"
                                className="btn btn-primary mg-r-5"
                              >
                                Buscar
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        <p className="tx-12 tx-gray-500 mb-2 mg-b-10 d-flex fw-bold">
                          {`Busque entre los productos de la marca `}
                        </p>
                      </Form>
                    </Col>
                  </Card.Body>
                  <Col xl={12} lg={12} md={12} key={Math.random()}>
                    <Row>
                      {items
                        .filter((item: any) =>
                          item.articuloGrupoDescripcion
                            .toLowerCase()
                            .includes(filtroLocal.toLowerCase())
                        )
                        .map((articuloGrupo: any, i) => (
                          <Col
                            sm={6}
                            xl={4}
                            xxl={3}
                            lg={6}
                            md={6}
                            key={articuloGrupo.id}
                          >
                            <CardGrupo
                              articuloGrupo={articuloGrupo}
                              inCard={true}
                              key={articuloGrupo.id}
                              onClick={() => {
                                setSelectedGroup(articuloGrupo);
                                handleOpenModal(articuloGrupo);
                              }}
                            />
                          </Col>
                        ))}
                    </Row>
                  </Col>
                </Card>
              </Row>
            </div>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default Campana;
